import { createFileRoute } from '@tanstack/react-router';

import { ProjectGridView } from '../../../features/cost-to-produce/project-grid-view';
import { usePartnerId } from '../../../features/inbox/use-partner-name';

export const Route = createFileRoute('/operating-costs/cost-to-produce/project')({
  staticData: { breadcrumb: 'Project' },
  component: ProjectTab,
});

function ProjectTab() {
  const partnerId = usePartnerId();
  return <ProjectGridView partnerId={partnerId} />;
}
